var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 461.4 924.4",
    style: {
      enableBackground: "new 0 0 461.4 924.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#939393;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st1{fill:#F5F5F5;}\n\t.st2{fill:#EDEDED;}\n\t.st3{fill:#FFFFFF;stroke:#C1C1C1;stroke-width:0.7287;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#C1C1C1;stroke-width:0.7287;stroke-miterlimit:10;}\n\t.st5{fill:#D7D7D7;}\n\t.st6{fill:#D1D1D1;}\n\t.st7{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.9,6.2h-323c-35,0-63.3,28.4-63.3,63.3v60.8H4c-0.9,0-1.5,0.7-1.5,1.5v32c0,0.9,0.7,1.5,1.5,1.5h1.5v24.8 h-1c-1.2,0-2.1,0.9-2.1,2.1V254c0,1.2,0.9,2.1,2.1,2.1h1v11.6h-1c-1.2,0-2.1,0.9-2.1,2.1v61.8c0,1.2,0.9,2.1,2.1,2.1h1v519.9 c0,35,28.4,63.3,63.3,63.3h323.1c35,0,63.3-28.4,63.3-63.3v-784C455.3,34.6,426.9,6.2,391.9,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.4,246.7h-1v66h1c1.2,0,2.1-0.9,2.1-2.1v-61.8C458.5,247.7,457.5,246.7,456.4,246.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 59.1,
    className: "st1",
    width: 413.2,
    height: 815.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.4,899.8H46.9c-13.7,0-24.9-11.1-24.9-24.9V850h413.2v25C435.3,888.7,424.1,899.8,410.4,899.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M442,73.1H20.9V57.5c0-25.9,21-46.8,46.8-46.8h327.4c25.9,0,46.8,21,46.8,46.8v15.6H442z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M391.9,6.2h-323c-35,0-63.3,28.4-63.3,63.3v784.1c0,35,28.4,63.3,63.3,63.3H392c35,0,63.3-28.4,63.3-63.3v-784 C455.3,34.6,426.9,6.2,391.9,6.2z M428.3,856.8c0,19.3-15.6,34.9-34.9,34.9H66.6c-19.3,0-34.9-15.6-34.9-34.9V66.4 c0-19.3,15.6-34.9,34.9-34.9h55.1c0,0,7.5-0.8,7.5,5.9c0,3.8,0,5,0,5.3c0,9.9,8,17.9,17.9,17.9h165.6c9.9,0,17.9-8,17.9-17.9 c0-0.3,0-1.3,0-5c0-6.2,7-6.1,7-6.1h55.6c19.3,0,34.9,15.6,34.9,34.9v790.3H428.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M390.8,910.5H69.2c-30.9,0-56-25.1-56-56V68.7c0-30.9,25.1-56,56-56h321.6c30.9,0,56,25.1,56,56v785.8 C446.8,885.4,421.7,910.5,390.8,910.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M388.8,905.7H71.2c-29.4,0-53.2-23.8-53.2-53.2V70.7c0-29.4,23.8-53.2,53.2-53.2h317.6 c29.4,0,53.2,23.8,53.2,53.2v781.8C442,881.9,418.2,905.7,388.8,905.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 368.8,
    y1: 6.2,
    x2: 368.8,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 374.2,
    y1: 6.2,
    x2: 374.2,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 446.8,
    y1: 86,
    x2: 455.3,
    y2: 86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 446.8,
    y1: 91.1,
    x2: 455.3,
    y2: 91.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 5.5,
    y1: 85.5,
    x2: 13.2,
    y2: 85.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 5.5,
    y1: 90.8,
    x2: 13.2,
    y2: 90.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 446.8,
    y1: 831.4,
    x2: 455.3,
    y2: 831.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 446.8,
    y1: 836.5,
    x2: 455.3,
    y2: 836.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 5.5,
    y1: 830.9,
    x2: 13.2,
    y2: 830.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 5.5,
    y1: 836.2,
    x2: 13.2,
    y2: 836.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 86.2,
    y1: 910.5,
    x2: 86.2,
    y2: 917
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 91.8,
    y1: 910.5,
    x2: 91.8,
    y2: 917
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.5,165.4H4c-0.9,0-1.5-0.7-1.5-1.5v-32c0-0.9,0.7-1.5,1.5-1.5h1.5V165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.5,256.2h-1c-1.2,0-2.1-0.9-2.1-2.1v-61.8c0-1.2,0.9-2.1,2.1-2.1h1V256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.5,333.8h-1c-1.2,0-2.1-0.9-2.1-2.1v-61.8c0-1.2,0.9-2.1,2.1-2.1h1V333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M455.4,246.7h1c1.2,0,2.1,0.9,2.1,2.1v61.8c0,1.2-0.9,2.1-2.1,2.1h-1V246.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M249.2,44.1h-38.3c-2.1,0-3.8-1.7-3.8-3.8l0,0c0-2.1,1.7-3.8,3.8-3.8h38.3c2.1,0,3.8,1.7,3.8,3.8l0,0 C253,42.4,251.3,44.1,249.2,44.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 311,
    cy: 40.1,
    r: 8.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.8,
    y: 53.2,
    className: "st6",
    width: 3.1,
    height: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 52.1,
    className: "st6",
    width: 3.1,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 50.1,
    className: "st6",
    width: 3.1,
    height: 6.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.3,
    y: 48,
    className: "st6",
    width: 3.1,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.4,
    y: 45.9,
    className: "st6",
    width: 3.1,
    height: 10.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.9,
    y: 46.9,
    className: "st6",
    width: 14.6,
    height: 6.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M408.6,55.4h-18.7V45h18.7V55.4z M390.9,54.3h16.7V46h-16.7V54.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 408.1,
    y: 48,
    className: "st6",
    width: 2.6,
    height: 4.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M366.7,48.3l-1.2-1.2c2.3-2.3,5.2-3.5,8.4-3.5c3.2,0,6.1,1.2,8.4,3.4l-1.2,1.2c-1.9-1.9-4.5-3-7.2-3 C371.2,45.3,368.7,46.4,366.7,48.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M369.3,51l-1.2-1.2c1.6-1.6,3.6-2.4,5.8-2.4c2.2,0,4.3,0.8,5.8,2.4l-1.2,1.2c-1.2-1.2-2.9-1.9-4.6-1.9 C372.3,49,370.6,49.7,369.3,51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M371.8,53.5l-1.2-1.2c0.8-0.8,2.1-1.4,3.3-1.4c1.2,0,2.4,0.5,3.3,1.4l-1.2,1.2c-0.5-0.5-1.2-0.8-2.1-0.8 C373.2,52.7,372.5,53,371.8,53.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 373.9,
    cy: 55.6,
    r: 1
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.9,56.3l1.3-0.1c0.1,0.7,0.4,1.1,0.7,1.3c0.3,0.3,0.8,0.4,1.2,0.4c0.4,0,0.8-0.1,1.2-0.3 c0.4-0.1,0.5-0.4,0.8-0.8c0.3-0.4,0.4-0.8,0.5-1.3s0.3-1.2,0.3-1.7c0,0,0-0.1,0-0.3c-0.3,0.4-0.7,0.8-1.2,1.1S71.6,55,71.1,55 c-0.9,0-1.7-0.4-2.4-1.1s-0.9-1.6-0.9-2.7c0-1.2,0.4-2.1,1.1-2.8s1.6-1.1,2.5-1.1c0.8,0,1.5,0.3,2,0.7s1.1,0.9,1.5,1.7 s0.5,1.9,0.5,3.2c0,1.5-0.1,2.7-0.5,3.5s-0.8,1.5-1.5,2s-1.3,0.7-2.3,0.7s-1.6-0.3-2.1-0.8C68.5,57.7,68.1,57.2,67.9,56.3z  M73.8,51.2c0-0.8-0.3-1.5-0.7-1.9c-0.4-0.4-0.9-0.7-1.6-0.7s-1.2,0.3-1.6,0.8s-0.7,1.2-0.7,2c0,0.7,0.3,1.3,0.7,1.7 s0.9,0.7,1.6,0.7s1.2-0.3,1.6-0.7S73.8,52.1,73.8,51.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.4,52.2v-1.6H79v1.6H77.4z M77.4,58.9v-1.6H79v1.6H77.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.8,58.9v-2.8h-5v-1.3l5.2-7.5h1.1v7.5h1.6v1.3h-1.6v2.8H85.8z M85.8,54.9v-5.2l-3.6,5.2H85.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M95.4,58.9h-1.5v-9c-0.4,0.3-0.8,0.7-1.3,0.9c-0.5,0.3-1.1,0.5-1.5,0.7v-1.3c0.8-0.4,1.5-0.8,2-1.3 s1.1-1.1,1.2-1.5h0.9v11.5C95.2,58.9,95.4,58.9,95.4,58.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPhone);
export default __webpack_public_path__ + "static/media/bgPhone.8ebb360568970dcfca4a3de7810578e7.svg";
export { ForwardRef as ReactComponent };